import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How can a custom logistics app streamline my operations?",
    answer: `<p>A tailored logistics app optimizes route planning, automates dispatch processes, tracks shipments in real-time, and enhances communication between drivers and managers, reducing manual errors and improving efficiency.</p>`,
  },
  {
    question: "Can a logistics app scale as my business grows?",
    answer: ` <p>Yes, we develop logistics apps with scalable architecture that adapts to your growing operational needs, handling increased volumes of shipments, users, and data without compromising performance.</p>`,
  },
  {
    question: "What features are essential in a logistics app?",
    answer: `<p>Key features include real-time GPS tracking, route optimization, driver management, order and inventory tracking, and seamless integrations with existing enterprise systems for a unified logistics solution.</p>`,
  },
  {
    question: "How secure are logistics apps developed by TekRevol?",
    answer: `<p>We prioritize data security by implementing end-to-end encryption, multi-factor authentication, and compliance with industry standards to safeguard sensitive data such as shipment details and customer information.</p>`,
  },
  {
    question: "How long does it take to develop a logistics app?",
    answer: ` <p>The timeline depends on the complexity and features of the app, but typically, a custom logistics app can take 3-6 months from ideation to deployment.
</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#fff" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>
                Logistics <span>App Development</span> FAQs
              </h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
